import type { JSX } from 'react'

import { IBIconProps } from '@pages/IntroducingBroker/assets/icon.types'

export function InitialTierIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z'
        fill='white'
        stroke='#EBEFF6'
      />
      <path
        d='M29.0286 12.3164C29.1032 12.3164 29.1751 12.325 29.2483 12.3311L25.8293 18.252H21.5256C21.003 18.252 20.5196 18.5308 20.259 18.9834L17.7864 23.2695C17.5258 23.7222 17.5258 24.2798 17.7864 24.7324L20.259 29.0176C20.5196 29.4701 21.003 29.7489 21.5256 29.749H25.8313V29.748L29.2493 35.6689C29.1762 35.675 29.1031 35.6836 29.0286 35.6836H18.9719C17.9097 35.6836 16.9276 35.1168 16.3958 34.1963L11.3665 25.4863C10.8349 24.566 10.8349 23.434 11.3665 22.5137L16.3958 13.8037C16.9276 12.8832 17.9097 12.3164 18.9719 12.3164H29.0286ZM31.6038 13.8047L36.6331 22.5146V22.5166C37.1647 23.437 37.1647 24.5689 36.6331 25.4893L31.6038 34.1992C31.5672 34.2632 31.5228 34.3219 31.4817 34.3828L28.0637 28.4619L30.2151 24.7334C30.4756 24.2808 30.4757 23.7231 30.2151 23.2705L28.0618 19.541L31.4807 13.6211C31.5217 13.6818 31.5658 13.741 31.6038 13.8047Z'
        fill='#B3C5E0'
      />
    </svg>
  )
}

export function BronzeQuarterIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z'
        fill='white'
        stroke='#EBEFF6'
      />
      <path
        d='M29.0286 12.3164C29.1032 12.3164 29.1751 12.325 29.2483 12.3311L25.8293 18.252H21.5256C21.003 18.252 20.5196 18.5308 20.259 18.9834L17.7864 23.2695C17.5258 23.7222 17.5258 24.2798 17.7864 24.7324L20.259 29.0176C20.5196 29.4701 21.003 29.7489 21.5256 29.749H25.8313V29.748L29.2493 35.6689C29.1762 35.675 29.1031 35.6836 29.0286 35.6836H18.9719C17.9097 35.6836 16.9276 35.1168 16.3958 34.1963L11.3665 25.4863C10.8349 24.566 10.8349 23.434 11.3665 22.5137L16.3958 13.8037C16.9276 12.8832 17.9097 12.3164 18.9719 12.3164H29.0286ZM31.6038 13.8047L36.6331 22.5146V22.5166C37.1647 23.437 37.1647 24.5689 36.6331 25.4893L31.6038 34.1992C31.5672 34.2632 31.5228 34.3219 31.4817 34.3828L28.0637 28.4619L30.2151 24.7334C30.4756 24.2808 30.4757 23.7231 30.2151 23.2705L28.0618 19.541L31.4807 13.6211C31.5217 13.6818 31.5658 13.741 31.6038 13.8047Z'
        fill='#B3C5E0'
      />
      <mask
        id='mask0_3189_16718'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='10'
        y='12'
        width='28'
        height='24'
      >
        <path
          d='M29.0286 12.3164C29.1032 12.3164 29.1751 12.325 29.2483 12.3311L25.8293 18.252H21.5256C21.003 18.252 20.5196 18.5308 20.259 18.9834L17.7864 23.2695C17.5258 23.7222 17.5258 24.2798 17.7864 24.7324L20.259 29.0176C20.5196 29.4701 21.003 29.7489 21.5256 29.749H25.8313V29.748L29.2493 35.6689C29.1762 35.675 29.1031 35.6836 29.0286 35.6836H18.9719C17.9097 35.6836 16.9276 35.1168 16.3958 34.1963L11.3665 25.4863C10.8349 24.566 10.8349 23.434 11.3665 22.5137L16.3958 13.8037C16.9276 12.8832 17.9097 12.3164 18.9719 12.3164H29.0286ZM31.6038 13.8047L36.6331 22.5146V22.5166C37.1647 23.437 37.1647 24.5689 36.6331 25.4893L31.6038 34.1992C31.5672 34.2632 31.5228 34.3219 31.4817 34.3828L28.0637 28.4619L30.2151 24.7334C30.4756 24.2808 30.4757 23.7231 30.2151 23.2705L28.0618 19.541L31.4807 13.6211C31.5217 13.6818 31.5658 13.741 31.6038 13.8047Z'
          fill='#B3C5E0'
        />
      </mask>
      <g mask='url(#mask0_3189_16718)'>
        <rect x='23.9473' y='11' width='14.0526' height='13.132' fill='#E6003D' />
      </g>
    </svg>
  )
}

export function BronzeHalfIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z'
        fill='white'
        stroke='#EBEFF6'
      />
      <path
        d='M29.0283 12.3164C29.103 12.3164 29.1749 12.325 29.248 12.3311L25.8291 18.252H21.5254C21.0027 18.252 20.5194 18.5308 20.2588 18.9834L17.7861 23.2695C17.5256 23.7222 17.5255 24.2798 17.7861 24.7324L20.2588 29.0176C20.5194 29.4701 21.0027 29.7489 21.5254 29.749H25.8311V29.748L29.249 35.6689C29.176 35.675 29.1029 35.6836 29.0283 35.6836H18.9717C17.9094 35.6836 16.9274 35.1168 16.3955 34.1963L11.3662 25.4863C10.8346 24.566 10.8346 23.434 11.3662 22.5137L16.3955 13.8037C16.9274 12.8832 17.9094 12.3164 18.9717 12.3164H29.0283ZM31.6035 13.8047L36.6328 22.5146V22.5166C37.1645 23.437 37.1644 24.5689 36.6328 25.4893L31.6035 34.1992C31.5669 34.2632 31.5226 34.3219 31.4814 34.3828L28.0635 28.4619L30.2148 24.7334C30.4754 24.2808 30.4754 23.7231 30.2148 23.2705L28.0615 19.541L31.4805 13.6211C31.5215 13.6818 31.5656 13.741 31.6035 13.8047Z'
        fill='#B3C5E0'
      />
      <mask
        id='mask0_2983_18016'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='10'
        y='12'
        width='28'
        height='24'
      >
        <path
          d='M29.0283 12.3164C29.103 12.3164 29.1749 12.325 29.248 12.3311L25.8291 18.252H21.5254C21.0027 18.252 20.5194 18.5308 20.2588 18.9834L17.7861 23.2695C17.5256 23.7222 17.5255 24.2798 17.7861 24.7324L20.2588 29.0176C20.5194 29.4701 21.0027 29.7489 21.5254 29.749H25.8311V29.748L29.249 35.6689C29.176 35.675 29.1029 35.6836 29.0283 35.6836H18.9717C17.9094 35.6836 16.9274 35.1168 16.3955 34.1963L11.3662 25.4863C10.8346 24.566 10.8346 23.434 11.3662 22.5137L16.3955 13.8037C16.9274 12.8832 17.9094 12.3164 18.9717 12.3164H29.0283ZM31.6035 13.8047L36.6328 22.5146V22.5166C37.1645 23.437 37.1644 24.5689 36.6328 25.4893L31.6035 34.1992C31.5669 34.2632 31.5226 34.3219 31.4814 34.3828L28.0635 28.4619L30.2148 24.7334C30.4754 24.2808 30.4754 23.7231 30.2148 23.2705L28.0615 19.541L31.4805 13.6211C31.5215 13.6818 31.5656 13.741 31.6035 13.8047Z'
          fill='#B3C5E0'
        />
      </mask>
      <g mask='url(#mask0_2983_18016)'>
        <rect x='23.9473' y='11' width='14.0526' height='13.132' fill='#E6003D' />
        <rect x='23.9473' y='24.132' width='14.0526' height='12.1219' fill='#E6003D' />
      </g>
    </svg>
  )
}

export function BronzeThreeQuarterIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z'
        fill='white'
        stroke='#EBEFF6'
      />
      <path
        d='M29.0283 12.3164C29.103 12.3164 29.1749 12.325 29.248 12.3311L25.8291 18.252H21.5254C21.0027 18.252 20.5194 18.5308 20.2588 18.9834L17.7861 23.2695C17.5256 23.7222 17.5255 24.2798 17.7861 24.7324L20.2588 29.0176C20.5194 29.4701 21.0027 29.7489 21.5254 29.749H25.8311V29.748L29.249 35.6689C29.176 35.675 29.1029 35.6836 29.0283 35.6836H18.9717C17.9094 35.6836 16.9274 35.1168 16.3955 34.1963L11.3662 25.4863C10.8346 24.566 10.8346 23.434 11.3662 22.5137L16.3955 13.8037C16.9274 12.8832 17.9094 12.3164 18.9717 12.3164H29.0283ZM31.6035 13.8047L36.6328 22.5146V22.5166C37.1645 23.437 37.1644 24.5689 36.6328 25.4893L31.6035 34.1992C31.5669 34.2632 31.5226 34.3219 31.4814 34.3828L28.0635 28.4619L30.2148 24.7334C30.4754 24.2808 30.4754 23.7231 30.2148 23.2705L28.0615 19.541L31.4805 13.6211C31.5215 13.6818 31.5656 13.741 31.6035 13.8047Z'
        fill='#B3C5E0'
      />
      <mask
        id='mask0_2983_18027'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='10'
        y='12'
        width='28'
        height='24'
      >
        <path
          d='M29.0283 12.3164C29.103 12.3164 29.1749 12.325 29.248 12.3311L25.8291 18.252H21.5254C21.0027 18.252 20.5194 18.5308 20.2588 18.9834L17.7861 23.2695C17.5256 23.7222 17.5255 24.2798 17.7861 24.7324L20.2588 29.0176C20.5194 29.4701 21.0027 29.7489 21.5254 29.749H25.8311V29.748L29.249 35.6689C29.176 35.675 29.1029 35.6836 29.0283 35.6836H18.9717C17.9094 35.6836 16.9274 35.1168 16.3955 34.1963L11.3662 25.4863C10.8346 24.566 10.8346 23.434 11.3662 22.5137L16.3955 13.8037C16.9274 12.8832 17.9094 12.3164 18.9717 12.3164H29.0283ZM31.6035 13.8047L36.6328 22.5146V22.5166C37.1645 23.437 37.1644 24.5689 36.6328 25.4893L31.6035 34.1992C31.5669 34.2632 31.5226 34.3219 31.4814 34.3828L28.0635 28.4619L30.2148 24.7334C30.4754 24.2808 30.4754 23.7231 30.2148 23.2705L28.0615 19.541L31.4805 13.6211C31.5215 13.6818 31.5656 13.741 31.6035 13.8047Z'
          fill='#B3C5E0'
        />
      </mask>
      <g mask='url(#mask0_2983_18027)'>
        <rect x='23.9473' y='11' width='14.0526' height='13.132' fill='#E6003D' />
        <rect x='23.9473' y='24.132' width='14.0526' height='12.1219' fill='#E6003D' />
        <rect x='9.89453' y='24.132' width='14.0526' height='12.1219' fill='#E6003D' />
      </g>
    </svg>
  )
}

export function BronzeIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#FF6D2E'
      />
      <path
        d='M29.0288 12.3164C29.1035 12.3164 29.1754 12.325 29.2485 12.3311L25.8296 18.252H21.5259C21.0032 18.252 20.5199 18.5308 20.2593 18.9834L17.7866 23.2695C17.526 23.7222 17.526 24.2798 17.7866 24.7324L20.2593 29.0176C20.5198 29.4701 21.0032 29.7489 21.5259 29.749H25.8315V29.748L29.2495 35.6689C29.1765 35.675 29.1034 35.6836 29.0288 35.6836H18.9722C17.9099 35.6836 16.9279 35.1168 16.396 34.1963L11.3667 25.4863C10.8351 24.566 10.8351 23.434 11.3667 22.5137L16.396 13.8037C16.9279 12.8832 17.9099 12.3164 18.9722 12.3164H29.0288ZM31.604 13.8047L36.6333 22.5146V22.5166C37.165 23.437 37.1649 24.5689 36.6333 25.4893L31.604 34.1992C31.5674 34.2632 31.5231 34.3219 31.4819 34.3828L28.064 28.4619L30.2153 24.7334C30.4758 24.2808 30.4759 23.7231 30.2153 23.2705L28.062 19.541L31.481 13.6211C31.522 13.6818 31.566 13.741 31.604 13.8047Z'
        fill='white'
      />
    </svg>
  )
}

export function SilverIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#B3C5E0'
      />
      <path
        d='M29.0288 12.3164C29.1035 12.3164 29.1754 12.325 29.2485 12.3311L25.8296 18.252H21.5259C21.0032 18.252 20.5199 18.5308 20.2593 18.9834L17.7866 23.2695C17.526 23.7222 17.526 24.2798 17.7866 24.7324L20.2593 29.0176C20.5198 29.4701 21.0032 29.7489 21.5259 29.749H25.8315V29.748L29.2495 35.6689C29.1765 35.675 29.1034 35.6836 29.0288 35.6836H18.9722C17.9099 35.6836 16.9279 35.1168 16.396 34.1963L11.3667 25.4863C10.8351 24.566 10.8351 23.434 11.3667 22.5137L16.396 13.8037C16.9279 12.8832 17.9099 12.3164 18.9722 12.3164H29.0288ZM31.604 13.8047L36.6333 22.5146V22.5166C37.165 23.437 37.1649 24.5689 36.6333 25.4893L31.604 34.1992C31.5674 34.2632 31.5231 34.3219 31.4819 34.3828L28.064 28.4619L30.2153 24.7334C30.4758 24.2808 30.4759 23.7231 30.2153 23.2705L28.062 19.541L31.481 13.6211C31.522 13.6818 31.566 13.741 31.604 13.8047Z'
        fill='white'
      />
    </svg>
  )
}

export function GoldIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#FFD60B'
      />
      <path
        d='M29.0288 12.3164C29.1035 12.3164 29.1754 12.325 29.2485 12.3311L25.8296 18.252H21.5259C21.0032 18.252 20.5199 18.5308 20.2593 18.9834L17.7866 23.2695C17.526 23.7222 17.526 24.2798 17.7866 24.7324L20.2593 29.0176C20.5198 29.4701 21.0032 29.7489 21.5259 29.749H25.8315V29.748L29.2495 35.6689C29.1765 35.675 29.1034 35.6836 29.0288 35.6836H18.9722C17.9099 35.6836 16.9279 35.1168 16.396 34.1963L11.3667 25.4863C10.8351 24.566 10.8351 23.434 11.3667 22.5137L16.396 13.8037C16.9279 12.8832 17.9099 12.3164 18.9722 12.3164H29.0288ZM31.604 13.8047L36.6333 22.5146V22.5166C37.165 23.437 37.1649 24.5689 36.6333 25.4893L31.604 34.1992C31.5674 34.2632 31.5231 34.3219 31.4819 34.3828L28.064 28.4619L30.2153 24.7334C30.4758 24.2808 30.4759 23.7231 30.2153 23.2705L28.062 19.541L31.481 13.6211C31.522 13.6818 31.566 13.741 31.604 13.8047Z'
        fill='white'
      />
    </svg>
  )
}

export function PlatinumIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#7A899F'
      />
      <path
        d='M29.0288 12.3164C29.1035 12.3164 29.1754 12.325 29.2485 12.3311L25.8296 18.252H21.5259C21.0032 18.252 20.5199 18.5308 20.2593 18.9834L17.7866 23.2695C17.526 23.7222 17.526 24.2798 17.7866 24.7324L20.2593 29.0176C20.5198 29.4701 21.0032 29.7489 21.5259 29.749H25.8315V29.748L29.2495 35.6689C29.1765 35.675 29.1034 35.6836 29.0288 35.6836H18.9722C17.9099 35.6836 16.9279 35.1168 16.396 34.1963L11.3667 25.4863C10.8351 24.566 10.8351 23.434 11.3667 22.5137L16.396 13.8037C16.9279 12.8832 17.9099 12.3164 18.9722 12.3164H29.0288ZM31.604 13.8047L36.6333 22.5146V22.5166C37.165 23.437 37.1649 24.5689 36.6333 25.4893L31.604 34.1992C31.5674 34.2632 31.5231 34.3219 31.4819 34.3828L28.064 28.4619L30.2153 24.7334C30.4758 24.2808 30.4759 23.7231 30.2153 23.2705L28.062 19.541L31.481 13.6211C31.522 13.6818 31.566 13.741 31.604 13.8047Z'
        fill='white'
      />
    </svg>
  )
}

export function DiamondIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#E81AFF'
      />
      <path
        d='M29.0288 12.3164C29.1035 12.3164 29.1754 12.325 29.2485 12.3311L25.8296 18.252H21.5259C21.0032 18.252 20.5199 18.5308 20.2593 18.9834L17.7866 23.2695C17.526 23.7222 17.526 24.2798 17.7866 24.7324L20.2593 29.0176C20.5198 29.4701 21.0032 29.7489 21.5259 29.749H25.8315V29.748L29.2495 35.6689C29.1765 35.675 29.1034 35.6836 29.0288 35.6836H18.9722C17.9099 35.6836 16.9279 35.1168 16.396 34.1963L11.3667 25.4863C10.8351 24.566 10.8351 23.434 11.3667 22.5137L16.396 13.8037C16.9279 12.8832 17.9099 12.3164 18.9722 12.3164H29.0288ZM31.604 13.8047L36.6333 22.5146V22.5166C37.165 23.437 37.1649 24.5689 36.6333 25.4893L31.604 34.1992C31.5674 34.2632 31.5231 34.3219 31.4819 34.3828L28.064 28.4619L30.2153 24.7334C30.4758 24.2808 30.4759 23.7231 30.2153 23.2705L28.062 19.541L31.481 13.6211C31.522 13.6818 31.566 13.741 31.604 13.8047Z'
        fill='white'
      />
    </svg>
  )
}

export function EliteIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#6A14FF'
      />
      <path
        d='M29.0288 12.3164C29.1035 12.3164 29.1754 12.325 29.2485 12.3311L25.8296 18.252H21.5259C21.0032 18.252 20.5199 18.5308 20.2593 18.9834L17.7866 23.2695C17.526 23.7222 17.526 24.2798 17.7866 24.7324L20.2593 29.0176C20.5198 29.4701 21.0032 29.7489 21.5259 29.749H25.8315V29.748L29.2495 35.6689C29.1765 35.675 29.1034 35.6836 29.0288 35.6836H18.9722C17.9099 35.6836 16.9279 35.1168 16.396 34.1963L11.3667 25.4863C10.8351 24.566 10.8351 23.434 11.3667 22.5137L16.396 13.8037C16.9279 12.8832 17.9099 12.3164 18.9722 12.3164H29.0288ZM31.604 13.8047L36.6333 22.5146V22.5166C37.165 23.437 37.1649 24.5689 36.6333 25.4893L31.604 34.1992C31.5674 34.2632 31.5231 34.3219 31.4819 34.3828L28.064 28.4619L30.2153 24.7334C30.4758 24.2808 30.4759 23.7231 30.2153 23.2705L28.062 19.541L31.481 13.6211C31.522 13.6818 31.566 13.741 31.604 13.8047Z'
        fill='white'
      />
    </svg>
  )
}

export function ElitePlusIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#5500DD'
      />
      <path
        d='M29.0288 12.3164C29.1035 12.3164 29.1754 12.325 29.2485 12.3311L25.8296 18.252H21.5259C21.0032 18.252 20.5199 18.5308 20.2593 18.9834L17.7866 23.2695C17.526 23.7222 17.526 24.2798 17.7866 24.7324L20.2593 29.0176C20.5198 29.4701 21.0032 29.7489 21.5259 29.749H25.8315V29.748L29.2495 35.6689C29.1765 35.675 29.1034 35.6836 29.0288 35.6836H18.9722C17.9099 35.6836 16.9279 35.1168 16.396 34.1963L11.3667 25.4863C10.8351 24.566 10.8351 23.434 11.3667 22.5137L16.396 13.8037C16.9279 12.8832 17.9099 12.3164 18.9722 12.3164H29.0288ZM31.604 13.8047L36.6333 22.5146V22.5166C37.165 23.437 37.1649 24.5689 36.6333 25.4893L31.604 34.1992C31.5674 34.2632 31.5231 34.3219 31.4819 34.3828L28.064 28.4619L30.2153 24.7334C30.4758 24.2808 30.4759 23.7231 30.2153 23.2705L28.062 19.541L31.481 13.6211C31.522 13.6818 31.566 13.741 31.604 13.8047Z'
        fill='white'
      />
    </svg>
  )
}

export function LegendIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#FF0544'
      />
      <path
        d='M29.0288 12.3164C29.1035 12.3164 29.1754 12.325 29.2485 12.3311L25.8296 18.252H21.5259C21.0032 18.252 20.5199 18.5308 20.2593 18.9834L17.7866 23.2695C17.526 23.7222 17.526 24.2798 17.7866 24.7324L20.2593 29.0176C20.5198 29.4701 21.0032 29.7489 21.5259 29.749H25.8315V29.748L29.2495 35.6689C29.1765 35.675 29.1034 35.6836 29.0288 35.6836H18.9722C17.9099 35.6836 16.9279 35.1168 16.396 34.1963L11.3667 25.4863C10.8351 24.566 10.8351 23.434 11.3667 22.5137L16.396 13.8037C16.9279 12.8832 17.9099 12.3164 18.9722 12.3164H29.0288ZM31.604 13.8047L36.6333 22.5146V22.5166C37.165 23.437 37.1649 24.5689 36.6333 25.4893L31.604 34.1992C31.5674 34.2632 31.5231 34.3219 31.4819 34.3828L28.064 28.4619L30.2153 24.7334C30.4758 24.2808 30.4759 23.7231 30.2153 23.2705L28.062 19.541L31.481 13.6211C31.522 13.6818 31.566 13.741 31.604 13.8047Z'
        fill='white'
      />
    </svg>
  )
}

export function UltimateIcon(props: IBIconProps): JSX.Element {
  const { className } = props
  const size = props.size || 48
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#04142A'
      />
      <path
        d='M29.0288 12.3164C29.1035 12.3164 29.1754 12.325 29.2485 12.3311L25.8296 18.252H21.5259C21.0032 18.252 20.5199 18.5308 20.2593 18.9834L17.7866 23.2695C17.526 23.7222 17.526 24.2798 17.7866 24.7324L20.2593 29.0176C20.5198 29.4701 21.0032 29.7489 21.5259 29.749H25.8315V29.748L29.2495 35.6689C29.1765 35.675 29.1034 35.6836 29.0288 35.6836H18.9722C17.9099 35.6836 16.9279 35.1168 16.396 34.1963L11.3667 25.4863C10.8351 24.566 10.8351 23.434 11.3667 22.5137L16.396 13.8037C16.9279 12.8832 17.9099 12.3164 18.9722 12.3164H29.0288ZM31.604 13.8047L36.6333 22.5146V22.5166C37.165 23.437 37.1649 24.5689 36.6333 25.4893L31.604 34.1992C31.5674 34.2632 31.5231 34.3219 31.4819 34.3828L28.064 28.4619L30.2153 24.7334C30.4758 24.2808 30.4759 23.7231 30.2153 23.2705L28.062 19.541L31.481 13.6211C31.522 13.6818 31.566 13.741 31.604 13.8047Z'
        fill='white'
      />
    </svg>
  )
}

export function UltraIcon(props: IBIconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#9C0034'
      />
      <path
        d='M29.0288 12.3164C29.1035 12.3164 29.1754 12.325 29.2485 12.3311L25.8296 18.252H21.5259C21.0032 18.252 20.5199 18.5308 20.2593 18.9834L17.7866 23.2695C17.526 23.7222 17.526 24.2798 17.7866 24.7324L20.2593 29.0176C20.5198 29.4701 21.0032 29.7489 21.5259 29.749H25.8315V29.748L29.2495 35.6689C29.1765 35.675 29.1034 35.6836 29.0288 35.6836H18.9722C17.9099 35.6836 16.9279 35.1168 16.396 34.1963L11.3667 25.4863C10.8351 24.566 10.8351 23.434 11.3667 22.5137L16.396 13.8037C16.9279 12.8832 17.9099 12.3164 18.9722 12.3164H29.0288ZM31.604 13.8047L36.6333 22.5146V22.5166C37.165 23.437 37.1649 24.5689 36.6333 25.4893L31.604 34.1992C31.5674 34.2632 31.5231 34.3219 31.4819 34.3828L28.064 28.4619L30.2153 24.7334C30.4758 24.2808 30.4759 23.7231 30.2153 23.2705L28.062 19.541L31.481 13.6211C31.522 13.6818 31.566 13.741 31.604 13.8047Z'
        fill='white'
      />
    </svg>
  )
}
